import { render, staticRenderFns } from "./AmioSidebar.vue?vue&type=template&id=46b1ac6d&scoped=true&"
import script from "./AmioSidebar.vue?vue&type=script&lang=js&"
export * from "./AmioSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AmioSidebar.vue?vue&type=style&index=0&id=46b1ac6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1ac6d",
  null
  
)

export default component.exports